<template>
<div>
  <v-dialog v-model="dialogManageCompany" persistent max-width="640px">
    <OverlayLoading :loading="loading" />
      <v-card class="pa-0">
        <!-- <v-card-title>
        </v-card-title> -->
        <v-card-text>
          <v-container>
            <v-row justify="end">
              <v-btn
                x-small
                icon
                @click="dialogManageCompany = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-row>
            <v-row style="margin-top: -2%;">
              <v-col cols="12">
                <span class="mb-0">ชื่อเครือ</span>
                <h1 class="ra-head-text-bold mb-0" style="color: #333333;">{{groupCompanyName }}</h1>
              </v-col>
            </v-row>
            <v-row class="" justify=center>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="mb-0">บริษัทในเครือ</span>
                <v-chip
                class="ml-2"
                color="#EFF4FD"
                text-color="#0370B7"
                small
              >
                <span>{{countCompany}}</span>
              </v-chip>
              </v-col>
            </v-row>
              <v-data-table
                :headers="headers"
                :items="desserts"
                :items-per-page="8"
                class="elevation-0"
                disable-sort
                :page.sync="pagination.current"
              >
                <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      color="#FFB300"
                      dark
                      icon
                      class="btn-del-dep mt-3 mb-3 ml-2"
                      @click="checkDel(item._id)"
                    >
                    <v-icon dark color="#464646" small>fa-trash</v-icon>
                    </v-btn>
                  </template>
                  <span class="label-table-action">ลบบริษัทในเครือ</span>
                </v-tooltip>
                </template>
              </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -2%;">
          <v-row justify="end">
            <v-btn class="" color="#3776E9" dark @click="dialogManageCompany = false">ตกลง</v-btn>
          </v-row>
          <v-spacer></v-spacer>
          <!-- <v-btn class="ma-2 sd" color="success" outlined dark @click="dialogManageCompany = false">ปิด</v-btn> -->
          <!-- <v-btn color="blue darken-1" text @click="submitEdit(desserts)">Save</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import { EventBus } from '@/EventBus'
import OverlayLoading from '../../_template/OverlayLoading.vue'
// import swal from 'sweetalert'
// import TableManageGroup from './_tableManageGroup'
export default {
  components: {
    // TableManageGroup
    OverlayLoading
  },
  data () {
    return {
      loading: false,
      dialog: false,
      dialogManageCompany: false,
      groupCompanyName: '',
      groupCompanyNameSelect: '',
      groupCompanyNameSelectList: '',
      groupCompanyId: '',
      countCompany: '',
      textTitle: '',
      preName: '',
      tokenUser: '',
      pagination: {},
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          sortable: false,
          value: 'no'
        },
        { text: 'ชื่อย่อบริษัท', value: 'companyFullName', align: 'start' }
      ],
      itemCompany: [
        'INET',
        'OGS'
      ],
      desserts: [{
        groupCompanyNameEng: '',
        _id: '',
        no: ''
      }]
    }
  },
  mounted () {
    EventBus.$on('opendialogmanage', this.openDialogManage)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    // this.getGroupCompanyList()
  },
  methods: {
    openDialogManage (value, item) {
      this.getGroupCompany(item._id)
      this.groupCompanyName = item.groupCompanyNameTh
      this.groupCompanyId = item._id
      this.countCompany = item.countCompany
      this.dialogManageCompany = value
    },
    closeDialogCreate () {
      this.dialogCreate = false
      EventBus.$emit('closedialogcreate', this.dialogCreate)
    },
    async getGroupCompany (id) {
      const temp = []
      this.desserts = []
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/companylist/` + id
      }).then((response) => {
        // this.desserts = response.data.result
        if (response.data.success) {
          if (response.data.result.length) {
            response.data.result.map((el, index) => {
              temp.push({
                no: index + 1,
                companyFullName: el.companyFullNameTh + ' - ' + el.companyFullNameEng,
                ...el
              })
            })
            this.desserts = temp
            this.countCompany = this.desserts.length
          }
        } else {
          // console.log(response)
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style scoped>
@import '../../../css/Re-Desing/Gobal-Design.css';
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.btn-del-dep {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
</style>
